var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  filter = require('lodash/filter'),
  decodeHtml = require('_utils/text'),
  unescape = require('lodash/unescape');

var AUTHORIZATION_TYPE = {
  ACCOUNTANT: 1,
  AUDITOR: 2
};

function CategoryInput(name, key, value) {
  this.name = name;
  this.key = key;
  this.value = ko.observable(value).extend({
    required: [
      {
        type: 'isValidCalculatorHour',
        message: 'Det er kun gyldig med hele eller halve timer'
      }
    ]
  });
}

CategoryInput.prototype.isValid = function() {
  var isValid = true;
  if (this.value.hasError()) {
    isValid = false;
  }
  return isValid;
};

function ExtendedCourse(params) {
  var self = this;
  this.API = params.api;
  this.parent = params.parent;
  this.links = params.parent.links;
  this.texts = params.parent.texts;
  this.preAnswers = params.preAnswers;
  this.isChangeInYear = ko.observable(false);
  this.addOrUpdateCallback = params.addOrUpdateCallback
    ? params.addOrUpdateCallback.bind(params.parent)
    : undefined;

  this.isEditingCourse = params.preAnswers ? true : false;
  this.removeCourseCallback = params.removeCourseCallback
    ? params.removeCourseCallback
    : function() {};

  if (this.isEditingCourse) {
    this.extendedCourseTitle = ko.observable('Rediger kurs');
  } else {
    this.extendedCourseTitle = ko.observable('Legg til oppdateringstimer');
  }

  this.id = ko.observable(-1);
  this.isLoading = ko.observable(false);
  this.validationTimer = null;
  // The input values.
  this.courseTitle = ko.observable().extend({
    required: [{ type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' }]
  });
  this.courseOrganizer = ko.observable().extend({
    required: [{ type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' }]
  });
  this.courseDate = ko.observable().extend({
    required: [{ type: 'isNotEmpty', message: 'Du må fylle inn en dato' }]
  });

  this.fieldsUpdate = ko.computed(function() {
    return self.courseTitle() + self.courseOrganizer() + self.courseDate();
  });
  this.fieldsUpdate.subscribe(function() {
    if (self.validationTimer !== null) {
      self.validationStatus('');
      window.clearTimeout(self.validationTimer);
    }
  });

  this.originalCategories = ko.observableArray([]);
  this.categories = ko.observableArray([]);
  this.categoriesAccountant = ko.observableArray([]);
  this.categoriesAuditor = ko.observableArray([]);
  // We need to know this when adding a new course. When we publish on this
  // channel we have to send the total hours done, not just what we added.
  this.hoursDone = ko.observable(0).syncWith('hoursDone', true);
  this.currentYear = ko.observable(0).subscribeTo('currentYearChange', true);
  this.period = ko.observableArray([]).subscribeTo('periodYears', true);

  this.validationStatus = ko.observable('');

  this.showAddCourse = ko.observable(false);
  // Radio buttons: If we are an accountant or auditor.
  this.authorizationType = ko.observable('1');
  this.isSelfStudy = ko.observable('false');
  // Listen to changes in the change of roles.
  this.authorizationType.subscribe(function(value) {
    if (parseInt(value, 10) === AUTHORIZATION_TYPE.ACCOUNTANT) {
      this.categories(this.categoriesAccountant());
    } else {
      this.categories(this.categoriesAuditor());
    }
  }, this);

  this.requiredFields = [
    this.courseTitle,
    this.courseOrganizer,
    this.courseDate
  ];

  this.categories.subscribe(function() {
    self.requiredFields = [
      self.courseTitle,
      self.courseOrganizer,
      self.courseDate
    ];
    self.requiredFields.push.apply(self.requiredFields, self.categories());
  });

  if (params.preAnswers) {
    this.originalCategories(params.preAnswers.categories);
    this.fillPreAnswers(params.preAnswers);
    this.id(params.preAnswers.sequencePk);
  } else {
    // Initally get the categories.
    this.getCategories();
  }
}

ExtendedCourse.prototype.fillPreAnswers = function(answers) {
  this.courseTitle(unescape(answers.title));
  if (answers.organizer) {
    this.courseOrganizer(unescape(answers.organizer));
  }
  if (answers.fromDate && answers.fromDate.length > 0) {
    var dateSplit = answers.fromDate.split('.');
    // New Date(year, month, day) - month January starts with value 0 so have to do dateSplit[1]-1.
    this.courseDate(new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0]));
  }
  if (answers.isSelfStudy) {
    this.isSelfStudy('true');
  }
  this.createCategories(answers.categories);
};

ExtendedCourse.prototype.getCategories = function() {
  APIHelper.get(
    this.API.authorizationCredits,
    function(response) {
      this.createCategories(response);
    }.bind(this)
  );
};

ExtendedCourse.prototype.createCategories = function(categories) {
  // Map the response into an object where we can have observables on the input values.
  this.categoriesAuditor(
    ko.utils.arrayMap(filter(categories, { AuthorizationType: 2 }), function(
      category
    ) {
      return new CategoryInput(
        category.Name,
        category.CategoryKey,
        category.Hours
      );
    })
  );
  this.categoriesAccountant(
    ko.utils.arrayMap(filter(categories, { AuthorizationType: 1 }), function(
      category
    ) {
      return new CategoryInput(
        category.Name,
        category.CategoryKey,
        category.Hours
      );
    })
  );
  // Default set it to Accountant
  this.categories(this.categoriesAccountant());
};

ExtendedCourse.prototype.validateFields = function(fields) {
  var isValid = true;

  for (var i = 0; i < fields.length; i++) {
    if (fields[i] instanceof CategoryInput) {
      // fields[i].value.hasError(!fields[i].isValid());
      if (!fields[i].isValid()) {
        isValid = false;
      }
    } else if (fields[i]() === undefined || fields[i]() === null) {
      fields[i].hasError(true);
    }
    if (
      !(fields[i] instanceof CategoryInput) &&
      fields[i] &&
      fields[i].hasError()
    ) {
      isValid = false;
    }
  }

  return isValid;
};

ExtendedCourse.prototype.clearFields = function() {
  // I have to set courseTitle twice in order to ensure that the
  // error message is shown on second attempt to register course.
  this.courseTitle('');
  this.courseTitle(null);
  this.courseTitle.hasError(undefined);
  this.courseTitle.isSuccessful(false);
  this.courseOrganizer('');
  this.courseOrganizer(null);
  this.courseOrganizer.hasError(undefined);
  this.courseOrganizer.isSuccessful(false);
  this.courseDate('');
  this.courseDate(undefined);
  this.courseDate.hasError(undefined);
  this.courseDate.isSuccessful(false);
  this.isSelfStudy('false');

  var categories = this.categoriesAccountant();
  var i = 0;
  for (i = 0; i < categories.length; i++) {
    categories[i].value(0);
  }
  categories = this.categoriesAuditor();
  i = 0;
  for (i = 0; i < categories.length; i++) {
    categories[i].value(0);
  }
};

ExtendedCourse.prototype.submitCourse = function() {
  if (!this.validateFields(this.requiredFields)) {
    this.validationStatus('errors');
    return;
  }

  var selectedDate = new Date(this.courseDate());

  var message = {
    Title: this.courseTitle(),
    Organizer: this.courseOrganizer(),
    Date: selectedDate.getFullYear() + '-' +
        ('0' + (selectedDate.getMonth() + 1)).slice(-2) + '-' +
        ('0' + selectedDate.getDate()).slice(-2) + 'T00:00:00',
    Credits: [],
    IsSelfStudy: this.isSelfStudy()
  };

  if (this.parent && this.parent.course && this.parent.course.CourseKey > 0) {
    message.CourseKey = this.parent.course.CourseKey;
  }
  var categories = this.categoriesAccountant();
  var tmpHours = 0;
  var i = 0,
    j = 0;
  var tmpVal;
  for (i = 0; i < categories.length; i++, j++) {
    tmpVal = categories[i].value();

    if (typeof tmpVal === 'string') {
      tmpVal = tmpVal.replace(',', '.');
    }

    tmpHours = parseFloat(tmpVal);
    if (isNaN(tmpHours)) {
      tmpHours = 0;
    }

    message.Credits.push({
      CategoryKey: categories[i].key,
      Hours: tmpHours
    });

    if (this.isEditingCourse) {
      this.originalCategories()[j].Hours = tmpHours;
    }
  }

  categories = this.categoriesAuditor();
  i = 0;
  for (i = 0; i < categories.length; i++, j++) {
    tmpVal = categories[i].value();

    if (typeof tmpVal === 'string') {
      tmpVal = tmpVal.replace(',', '.');
    }

    tmpHours = parseFloat(tmpVal);
    if (isNaN(tmpHours)) {
      tmpHours = 0;
    }

    message.Credits.push({
      CategoryKey: categories[i].key,
      Hours: tmpHours
    });

    if (this.isEditingCourse) {
      this.originalCategories()[j].Hours = tmpHours;
    }
  }

  if (this.preAnswers) {
    var dateSplit = this.preAnswers.fromDate.split('.');
    var oldFromDate = new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0]);
    var newFromDate = new Date(this.courseDate());
    this.isChangeInYear =
      oldFromDate.getFullYear() !== newFromDate.getFullYear();
  }

  this.isLoading(true);
  APIHelper.post(
    this.API.addOrUpdateExternalCourse,
    message,
    function() {
      this.isLoading(false);

      var addedYear = new Date(message.Date).getFullYear();
      var periods = this.period();

      // Only publish the hours to the display if the course is within the current period.
      if (
        periods.length !== 0 &&
        addedYear >= periods[0].Year &&
        addedYear <= periods[periods.length - 1].Year
      ) {
        ko.postbox.publish('changeInAbsence', {});
      }
      if (this.addOrUpdateCallback !== undefined) {
        this.addOrUpdateCallback();
      }
      // We only want to clear the fields when we're adding new courses - incase the user
      // will add more courses they don't have to manually remove each field.
      if (!this.isEditingCourse) {
        this.clearFields();
      } else {
        var tmpDate = new Date(this.courseDate());
        this.parent.updateCourseValues({
          title: message.Title,
          organizer: message.Organizer,
          fromDate:
            '' +
            tmpDate.getDate() +
            '.' +
            (tmpDate.getMonth() + 1) +
            '.' +
            tmpDate.getFullYear(),
          categories: this.originalCategories()
        });
      }

      this.validationStatus('success');
      this.startValidationTimer();
    }.bind(this),
    function(response) {
      this.isLoading(false);
      this.validationStatus('errors');
      this.startValidationTimer();
      var location = window.location.href || document.URL;
      APIHelper.post('/api/log/error', {
        message: 'API-error: extended-course.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + this.API.addOrUpdateExternalCourse
        ]
      });
    }.bind(this)
  );
};

ExtendedCourse.prototype.removeCourse = function() {
  var self = this;
  self.isLoading(true);
  APIHelper.delete(
    this.parent.API.removeCourseApi + '/' + this.parent.course.CourseKey,
    undefined,
    function() {
      self.isLoading(false);
      self.removeCourseCallback();
    }
  );
};

ExtendedCourse.prototype.startValidationTimer = function() {
  var self = this;
  this.validationTimer = window.setTimeout(function() {
    self.validationStatus('');
    self.validationTimer = null;
  }, 5000);
};

ExtendedCourse.prototype.toggleAddCourse = function() {
  this.showAddCourse(!this.showAddCourse());
};

ExtendedCourse.prototype.triggerNonStructuredHoursPopup = function() {
  ko.postbox.publish('openPopup', {
    modalTitle: decodeHtml(this.texts.nonStructuredHoursTitle),
    modalText: decodeHtml(this.texts.nonStructuredHoursDescription)
  });
};

module.exports = ExtendedCourse;
